import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { map, tap } from 'rxjs/operators';
import * as NewsApiActions from '@app/modules/news/actions/news-api.actions';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { State } from '@app/reducers';
import { inject } from '@angular/core';

export const canActivate: CanActivateFn = () => {
    const store = inject(Store<State>);

    return of(true).pipe(
        map(() => NewsApiActions.Clear()),
        tap((action: any) => store.dispatch(action)),
        map(() => true),
    );
};

export const canActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => canActivate(route, state);